import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BuildInfo } from '../BuildInfo';
import { catchError } from 'rxjs/operators';
import { BBResponseContainer } from '../common-services/response-container';
import { of } from 'rxjs';

@Injectable()
export class HeaderService {

  defaultTimeout = 600000;
  noValue = { data: { Build: { Number: 'N/A' } } };

  constructor(private http: HttpClient) { }

  getBuildInfo() {
    return this.http.get<BuildInfo>("/assets/TFS-Build-Report.json").pipe(catchError(error => of({ Build: { Number: 'unknown build' } })));
  }

  getServiceBuildInfo(serviceHostUrl: string) {
    let url = serviceHostUrl + "build";
    return this.http.get<BBResponseContainer>(url).pipe(catchError(error => of(this.noValue)));
  }
}
